var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-brake",attrs:{"id":"print-invest-wraper"}},[_vm._t("cover"),_c('page-section'),_c('three-section'),_c('PageButtomText',{staticClass:"page-splite-flag",attrs:{"text-obj":_vm.investText}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }